import useFunctionContext from '/druid/internal/useFunctionContext';

export default function useScrollOneRight() {
  const { scrollOneRight } = useFunctionContext();

  return scrollOneRight;
}
